import { Controller } from 'react-hook-form';
import { RadioGroup, Radio, Flex } from '@chakra-ui/react';

export default function RadioQuestion({
 question,
 control,
 themeId,
 defaultValues,
 surveyId,
}) {
 const questionName = surveyId
  ? `${surveyId}.radio_question_${question.id_question}`
  : themeId
  ? `radio_question_${question.id_question}_${themeId}`
  : `radio_question_${question.id_question}`;

 let defaultValue = '';
 if (surveyId && defaultValues[surveyId]) {
  defaultValue =
   defaultValues[surveyId][`radio_question_${question.id_question}`]?.value || '';
 } else {
  defaultValue = defaultValues[questionName]?.value || '';
 }

 return (
  <RadioGroup defaultValue={defaultValue}>
   <Flex gap='12px' flexWrap='wrap' className='questionary-app'>
    {question?.options?.map((option) => (
     <Controller
      key={option?.id_question_option_template}
      control={control}
      name={`${questionName}.value`}
      render={({ field: { onChange, onBlur } }) => (
       <Radio onChange={onChange} onBlur={onBlur} value={option.description} isReadOnly>
        {option.description}
       </Radio>
      )}
     />
    ))}
   </Flex>
  </RadioGroup>
 );
}
